import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full flex items-center"
}
const _hoisted_2 = { class: "text-center px-8 space-y-10" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary-faded text-xl font-semibold" }, "Ingen agenter tilgjengelig", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary space-y-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Vi har dessverre ingen agenter tilgjengelige nå, men vi kommer tilbake til deg så snart som mulig. "),
  /*#__PURE__*/_createElementVNode("div", null, " Hvor ønsker du at vi fortsetter samtalen? ")
], -1)
const _hoisted_6 = { class: "space-y-1.5 pt-1" }

import ActionButton from "@/features/shared/ActionButton.vue";
import { GConversationChannelItem } from "@/generated/graphql";
import { useGraphqlSdk } from "@/graphql/graphql-client";
import { getCurrentInstance, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoAgentAvailable',
  emits: ["email-click", "sms-click"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const instance = getCurrentInstance();
const tenant = instance?.appContext.config.globalProperties.$tenant;

const hasEmail = ref(false);
const hasSms = ref(false);
const loaded = ref(false);

const sdk = useGraphqlSdk();
sdk.GetConversationChannels({
  tenant: tenant
}).then(res => {
  hasEmail.value = res.connectedServices.indexOf(GConversationChannelItem.Email) !== -1;
  hasSms.value = res.connectedServices.indexOf(GConversationChannelItem.Sms) !== -1;
  loaded.value = true;
});

function onEmailClick() {
  emits("email-click");
}

function onSmsClick() {
  emits("sms-click");
}

return (_ctx: any,_cache: any) => {
  return (loaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (hasEmail.value)
                ? (_openBlock(), _createBlock(ActionButton, {
                    key: 0,
                    onClick: onEmailClick,
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("E-mail")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hasSms.value)
                ? (_openBlock(), _createBlock(ActionButton, {
                    key: 1,
                    onClick: onSmsClick,
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("SMS")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})